const _state = {
  counts: {},
}

const mutations = {
  updateSubmissionCount(state, { slideId, data }) {
    // eslint-disable-next-line no-param-reassign
    state.counts = {
      ...state.counts,
      [slideId]: data,
    }
  },
}

const actions = {
  updateSubmissionCountAction({ commit }, payload) {
    commit('updateSubmissionCount', payload)
  },
}

const getters = {
  getSubmissionCountBySlideId: (state) => (slideId) => {
    return state.counts[slideId]?.total || 0
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters,
}
